'use client'

import {
  motion,
  useReducedMotion,
  useScroll,
  useTransform,
} from 'framer-motion'
import { useRef } from 'react'

import { machuAssets } from '../machuAssets'

const ease = [0.22, 1, 0.36, 1] as const

export const Header = () => {
  const reduce = useReducedMotion()
  const off = !!reduce
  const headerRef = useRef<HTMLElement | null>(null)

  const { scrollYProgress } = useScroll({
    target: headerRef,
    offset: ['start start', 'end start'],
  })

  const parallaxY = useTransform(scrollYProgress, [0, 1], ['0%', '-18%'])

  const t = (delay: number) => ({
    duration: off ? 0 : 0.72,
    ease,
    delay: off ? 0 : delay,
  })

  return (
    <header
      ref={headerRef}
      className="relative h-80 overflow-hidden md:h-150"
    >
      <motion.div
        aria-hidden
        className="pointer-events-none absolute inset-0 -top-[12%] min-h-[124%] will-change-transform"
        style={{
          ...(reduce ? {} : { y: parallaxY }),
        }}
      >
        <img
          src={machuAssets.heroBg}
          alt=""
          width={1920}
          height={1080}
          sizes="100vw"
          decoding="async"
          fetchPriority="high"
          className="h-full min-h-full w-full object-cover object-center"
        />
      </motion.div>
      <div className="relative z-10 flex h-full w-full flex-col bg-gradient-to-t from-white from-0% via-white/45 via-[28%] to-transparent to-[68%]">
        <div className="mx-auto flex h-full w-full max-w-(--breakpoint-xl) flex-col px-4 pt-2 sm:px-6">
          <div className="mx-auto mt-12 w-11/12 max-w-2xl flex-1 sm:mt-14 md:mt-20 lg:max-w-3xl">
            <motion.div
              className="drop-shadow-[0_2px_6px_rgba(0,0,0,0.75)]"
              initial={off ? false : { y: 20 }}
              animate={{ y: 0 }}
              transition={t(0)}
            >
              <img
                id="title-logo"
                src={machuAssets.logo}
                alt="The Retreat: Machu Picchu"
                width={720}
                height={200}
                sizes="(max-width: 1024px) 67vw, 520px"
                decoding="async"
                className="mx-auto h-auto w-2/3 max-w-[min(100%,520px)]"
              />
            </motion.div>
            <motion.p
              className="mt-3 text-center font-machu text-lg font-medium tracking-wide text-white md:text-2xl"
              style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}
              initial={off ? false : { y: 16 }}
              animate={{ y: 0 }}
              transition={t(0.14)}
            >
              Sacred Valley • Machu Picchu • Cusco
            </motion.p>

            <motion.p
              className="mt-4 text-center"
              initial={off ? false : { y: 14 }}
              animate={{ y: 0 }}
              transition={t(0.28)}
            >
              <span
                className="font-machu text-2xl font-semibold text-white md:text-4xl"
                style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}
              >
                15<sup className="text-[0.65em]">th</sup> - 19
                <sup className="text-[0.65em]">th</sup> May 2027
              </span>
            </motion.p>
          </div>
        </div>
      </div>
    </header>
  )
}
